import { j as h } from "../../../../jsx-runtime.BREq8dyb.js";
import { Box as B } from "@mui/joy";
import { b as D } from "../../../../lodash.DGoHQECz.js";
import { memo as N, useState as L, useCallback as O, useEffect as V } from "react";
import { useErrorBoundary as q } from "react-error-boundary";
import G, { PromiseState as W } from "../../../Loader/Loader.js";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import { useFile as $ } from "../../contexts/FileContext/FileContext.js";
import { useIntrospection as J } from "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as K } from "../../contexts/SchemaContext/SchemaContext.js";
import { TypifyingProvider as M } from "../../contexts/TypificationContext/TypificationContext.js";
import { useWorker as Q } from "../../contexts/WorkerContext/WorkerContext.js";
import { ShowRows as U } from "../../types/index.js";
import { TableColumnFormatType as t } from "@decentriq/graphql/dist/enums";
const X = N(({
  children: P
}) => {
  const {
    showBoundary: v
  } = q(), {
    analyzeDataset: f
  } = Q(), {
    file: p,
    fileEncoding: g,
    fileHeaders: l,
    fileHasHeader: w,
    fileValuesDelimiter: c,
    fileDecimalSeparator: T
  } = $(), {
    setSchema: C
  } = K(), {
    introspecting: x
  } = J(), [E, y] = L(!1), F = Array.isArray(l) && l.length > 0, R = O(async (n, s, e, i, A, S, k) => {
    try {
      const I = async (r, o) => {
        const a = [{
          allowNull: !0,
          formatType: r
        }], m = {
          analyzeCsvOptions: {
            autofix: !1,
            decimalSeparator: A,
            prepareCsvOptions: {
              columns: a
            },
            validateCsvOptions: {
              hashColumns: void 0,
              numRowsToRecordForPreview: 0,
              previewRowFilter: U.All,
              recordPreview: !1,
              stopAtValidationFailure: !1,
              validationConfig: {
                config: {
                  columns: a
                },
                version: "v0"
              }
            }
          },
          file: n,
          parseCsvOptions: {
            delimiter: k,
            encoding: s,
            hasHeader: S,
            keepOnlyColumns: [o],
            keepOnlyRows: 50
          }
        };
        return await e(m);
      }, H = [t.String, t.PhoneNumberE164, t.Email, t.DateIso8601, t.HashSha256Hex, t.Float, t.Integer], d = [];
      for (let r = 0; r < i.length; r++) {
        let o;
        for (let a = 0; a < H.length; a++) {
          const m = H[a], z = await I(m, r), {
            numInvalidRowsTotal: j = 0
          } = z?.validation?.report?.report || {};
          (o === void 0 || j <= o.numInvalidRowsTotal) && (o = {
            formatType: m,
            numInvalidRowsTotal: j
          });
        }
        const {
          formatType: b = t.String
        } = o || {};
        d[r] = b;
      }
      return d.length > 0 ? d.map((r, o) => ({
        formatType: r,
        id: `column-${o}`,
        name: i[o],
        nullable: !0
      })) : void 0;
    } catch {
    }
  }, []), u = O((n = void 0, s = void 0) => {
    if (!x && f && p && c && F)
      return s?.() && y(!0), R(p, g, f, l, T, w, c).then((e) => (e && s?.() && C((i) => Array.isArray(e) && e.length > 0 ? D(i, {
        columns: e
      }) ? i : {
        columns: e
      } : i), e)).catch((e) => {
        v(new Error("Failed to typify file"));
      }).finally(() => {
        s?.() && y(!1);
      });
  }, [f, p, T, g, w, c, F, l, x, C, v, R]);
  return V(() => {
    let n = !0;
    return u(void 0, () => n), () => {
      n = !1;
    };
  }, [u]), /* @__PURE__ */ h.jsx(M, { value: {
    setTypifying: y,
    typify: u,
    typifying: E
  }, children: E ? /* @__PURE__ */ h.jsx(B, { sx: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  }, children: /* @__PURE__ */ h.jsx(G, { loadLabel: "Guessing data types…", loadState: W.Pending }) }) : P });
});
X.displayName = "TypificationContainer";
export {
  X as default
};
//# sourceMappingURL=TypificationContainer.js.map
